import { render } from "./confirm-order.vue?vue&type=template&id=5b1b4fbe&scoped=true"
import script from "./confirm-order.vue?vue&type=script&lang=js"
export * from "./confirm-order.vue?vue&type=script&lang=js"

import "./confirm-order.vue?vue&type=style&index=0&id=5b1b4fbe&lang=scss&scoped=true&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1b4fbe"]])

export default __exports__